import controller from './language-selector.controller'
import template from './templates/language-selector-dropdown.template.html'

export default {
  template,
  controller
}
